import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";

export interface MassMessageUser {
  follower: Follower;
  subscriber: boolean;
}

export interface MappedBlockedUsers {
  [key: string]: boolean;
}

export enum MessageSortTypeEnum {
  DEFAULT = 0,
  UNREAD = 1,
  UNREAD_OLDEST = 2,
}
